import { Nullable } from './common';
import { MapFilterBase } from './map';

export const TRADE_TYPE_KR = {
  TRADE: '매매',
  RENTAL: '전세',
  MONTHLY_RENTAL: '월세',
};

export type TRADE_TYPE_KR = typeof TRADE_TYPE_KR[keyof typeof TRADE_TYPE_KR];

export const TRADE_TYPE = {
  TRADE: 'TRADE',
  RENTAL: 'RENTAL',
  MONTHLY_RENTAL: 'MONTHLY_RENTAL',
};

export type TRADE_TYPE = typeof TRADE_TYPE[keyof typeof TRADE_TYPE];

export interface OfferFilter {
  area: number[];
  year: string;
  date: string[];
  deposit: number[];
  managementCost: number[];
  monthlyDeposit: number[];
  monthlyPrice: number[];
  price: number[];
  tradeType: TRADE_TYPE_KR[];
}

export interface OfferMapFilter extends MapFilterBase {
  areaMin: number;
  areaMax: number;
  availableYear: string;
  dateMin: string;
  dateMax: string;
  depositMin: number;
  depositMax: number;
  managementCostMin: number;
  managementCostMax: number;
  monthlyDepositMin: number;
  monthlyDepositMax: number;
  monthlyPriceMin: number;
  monthlyPriceMax: number;
  priceMin: number;
  priceMax: number;
  tradeType: TRADE_TYPE_KR[];
}

export interface OfferMarker {
  complexId: number;
  bldNm: string;
  center: { latitude: number; longitude: number };
  districtName: Nullable<string>;
  count: number;
}

export interface Complex {
  complexId: number;
  bldNm: string;
  complexPlatPlc: string;
  complexNum: number;
  complexUseDay: string;
  gapRangeMin: string;
  gapRangeMax: string;
  imageUrl: string;
  layoutPublicAreaMsMin: string;
  layoutPublicAreaMsMax: string;
}

export interface ComplexDetails {
  id: number;
  bldNm: string;
  complexId: number;
  sigunguCd: string;
  bjdongCd: string;
  bun: string;
  ji: string;
  district: string;
  roadAddress: string;
  complexPlatPlc: string;
  complexNewPlatPlc: string;
  complexLatCenter: number;
  complexLonCenter: number;
  categoryType: Nullable<string>;
  complexBldCd: string;
}
